import { useRef } from "react";
import ModalPop from "../../home/ModalPop";

const RightQuick = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="grid fixed right-0 bottom-48 lg:bottom-auto lg:right-[calc((100%-var(--container))/3)] lg:translate-x-5 lg:top-52 w-fit h-fit z-10 justify-items-center gap-2 lg:gap-4">
        <button
          type="button"
          onClick={() => window.open("https://blog.naver.com/mbc852000")}
          className="transition hover:scale-[1.02] active:scale-[0.98]"
        >
          <img
            src="/images/quickBlog.png"
            alt="하수구원킬케어 블로그"
            className="!relative w-auto h-full max-h-16 lg:max-h-20 object-contain"
          />
        </button>
        <button
          type="button"
          onClick={() => (window.location.href = "tel:010-8123-8285")}
          className="transition hover:scale-[1.02] active:scale-[0.98]"
        >
          <img
            src="/images/quickCall.png"
            alt="하수구원킬케어 전화"
            className="!relative w-auto h-full max-h-28 lg:max-h-36 object-contain"
          />
        </button>
        <button
          type="button"
          onClick={openfunc}
          className="transition hover:scale-[1.02] active:scale-[0.98]"
        >
          <img
            src="/images/quickContact.png"
            alt="하수구원킬케어 빠른 견적 문의"
            className="!relative w-auto h-full max-h-28 lg:max-h-36 object-contain"
          />
        </button>
      </div>
    </>
  );
};

export default RightQuick;
